package com.essntl.features.country.ui.allcountries

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.country.domain.model.CountryModel

data class AllCountriesState(
    val getAllCountries: State<List<CountryModel>> = State(),
)